import { useState } from "react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Download, FileText, FileSpreadsheet, FileType, Loader2 } from "lucide-react";
import { downloadExport } from "@/lib/download";
import { toast } from "sonner";

const FORMATS = [
  { fmt: "pdf", label: "PDF (impression)", icon: FileText },
  { fmt: "xlsx", label: "Excel (données)", icon: FileSpreadsheet },
  { fmt: "docx", label: "Word (rapport)", icon: FileType },
];

export default function ExportMenu({ basePath, filename = "export", extraQuery = "", label = "Exporter", testid = "export-menu" }) {
  const [loading, setLoading] = useState(false);

  const run = async (fmt) => {
    setLoading(true);
    try {
      const sep = basePath.includes("?") ? "&" : "?";
      const q = extraQuery ? `${sep}${extraQuery}&format=${fmt}` : `${sep}format=${fmt}`;
      await downloadExport(`${basePath}${q}`, `${filename}.${fmt}`);
      toast.success(`Export ${fmt.toUpperCase()} téléchargé`);
    } catch (e) {
      toast.error(e.message || "Échec de l'export");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="rounded-sm" data-testid={testid} disabled={loading}>
          {loading ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <Download className="h-4 w-4 mr-1.5" />}
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-sm">
        {FORMATS.map((f) => (
          <DropdownMenuItem key={f.fmt} onClick={() => run(f.fmt)} data-testid={`${testid}-${f.fmt}`} className="cursor-pointer">
            <f.icon className="h-4 w-4 mr-2 text-navy" strokeWidth={1.5} /> {f.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
